import { render, staticRenderFns } from "./PmtaConfigs.vue?vue&type=template&id=69d32ebc&scoped=true"
import script from "./PmtaConfigs.vue?vue&type=script&lang=js"
export * from "./PmtaConfigs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d32ebc",
  null
  
)

export default component.exports